import Switch from "@mui/material/Switch";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import WidgetSelect from "../../dashboard/components/WidgetSelect";
import { getMmOrderBookAction } from "../treasury.effects";

interface IProps {
  token: string;
}

const REFRESH_INTERVALS = [
  { value: 30, label: "30 seconds" },
  { value: 60, label: "1 minute" },
];

export default function CexOrdersFilters({ token }: IProps) {
  const [refresh, setRefresh] = useState(false);
  const [refreshInterval, setRefreshInterval] = useState(30);
  const dispatch = useDispatch();

  useEffect(() => {
    if (refresh) {
      const interval = setInterval(() => {
        dispatch(getMmOrderBookAction(token));
      }, refreshInterval * 1000);

      return () => clearInterval(interval);
    }
  }, [refresh, refreshInterval, token]);

  return (
    <div className="absolute top-[10px] right-4">
      <div
        className={classNames("text-sm flex items-center", {
          "text-text-2": !refresh,
        })}
      >
        <span className="mr-2">Refresh every</span>
        <WidgetSelect
          className={classNames({
            "text-text-2": !refresh,
          })}
          items={REFRESH_INTERVALS}
          selectedValue={refreshInterval}
          onValueChange={(value) => setRefreshInterval(value as number)}
        />
        <Switch
          checked={refresh}
          color="secondary"
          onChange={(e) => setRefresh(e.target.checked)}
        />
      </div>
    </div>
  );
}
